import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-278b4803"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-message" }, [
  /*#__PURE__*/_createTextVNode(" We currently show "),
  /*#__PURE__*/_createElementVNode("b", null, "no trailers"),
  /*#__PURE__*/_createTextVNode(" available at this location. ")
], -1))
const _hoisted_6 = { class: "button-content" }
const _hoisted_7 = {
  key: 1,
  class: "message"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header no-results-heading" }, "No results nearby", -1))
const _hoisted_9 = { class: "no-results-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.listView === 'selecttrailer' && _ctx.customerAtCurrentLocation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.messageText), 1),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_fbx_button, {
              "button-text": "Find Another Trailer",
              theme: "primary",
              onClick: _ctx.findTrailers
            }, null, 8, ["onClick"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, "Please contact your " + _toDisplayString(_ctx.contact) + " for further assistance.", 1)
        ]))
  ]))
}